import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import * as moment from "moment";
import { Subject } from "rxjs";
import { EncryptionService } from "src/app/_services/encryption.service";
import { ExcelService } from "src/app/_services/excel.service";
import { MentorshipDashboardService } from "src/app/_services/mentorship-dashboard.service";

declare const $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-rejected-req-by-mentor",
  templateUrl: "./rejected-req-by-mentor.component.html",
})
export class RejectedReqByMentorComponent implements OnInit {
  @ViewChild("datePicker", { static: false }) datePicker: ElementRef;
  startDate: any;
  endDate: any;
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [5], orderable: false }],
  };

  exportSmartMatchList: any = [];
  fieldsToIncludeExcel: any = [];
  exl: boolean = false;

  dtTrigger = new Subject();
  pendingReqArr: any = [];
  totalSmartMatch: any;
  modalReference: NgbActiveModal;
  modalCropper: NgbActiveModal;
  showloding = true;
  lodingImage = false;
  isSubmitted = false;
  dateInvalid: boolean = false;
  today: string = "";

  constructor(
    public router: Router,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: MentorshipDashboardService,
    private excelService: ExcelService
  ) {
    const now = new Date();
    this.today = now.toISOString().split("T")[0];
  }

  ngOnInit() {
    window.scroll(0, 0);
    const strtDate = sessionStorage.getItem("startDate");
    const endDate = sessionStorage.getItem("endDate");
    this.startDate = strtDate;
    this.endDate = endDate;
    this.getListing();
    this.pendingReq();
  }

  getListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[5, "desc"]],
      ajax: (dataTablesParameters: any, callback) => {
        const data = {
          type: "disconnected_rejected_requests_by_mentors",
          export: false,
          start_date: this.startDate,
          end_date: this.endDate,
        };

        const requestPayload = {
          ...dataTablesParameters,
          ...data,
        };

        const encryptedData = this.enc_dec.encrypt(
          JSON.stringify(requestPayload)
        );

        this.http
          .post<DataTablesResponse>(
            "/api/metric-list",
            { req_data: encryptedData },
            {}
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.pendingReqArr = resp["data"];
            this.totalSmartMatch = resp["recordsFiltered"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },

      columns: [
        { data: "id" },
        { data: "user_name" },
        { data: "connect_type" },
        { data: "connected_to_name" },
        { data: "connection_status" },
        { data: "created_at" },
      ],
    };
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
    $("#pending_request").on("page.dt", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }

  ngOnDestroy(): void {
    $("#pending_request").off("page.dt");
    this.dtTrigger.unsubscribe();
  }

  blockTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  onReset() {
    this.isSubmitted = false;
    this.startDate = "";
    this.endDate = "";
    sessionStorage.removeItem("startDate");
    sessionStorage.removeItem("endDate");
    const table = $("#pending_request").DataTable();
    table.ajax.reload(null, false);
    this.pendingReq();
  }

  onSearch() {
    this.isSubmitted = true;
    this.dateInvalid = false;

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    if (start > end) {
      this.dateInvalid = true;
      return;
    }
    const table = $("#pending_request").DataTable();
    table.ajax.reload(null, false);
    this.pendingReq();
  }

  pendingReq() {
    const data = {
      draw: 1,
      start: 0,
      length: 1,
      order: [
        {
          column: 5,
          dir: "desc",
        },
      ],
      search: {
        value: "",
        regex: false,
      },
      start_date: this.startDate,
      end_date: this.endDate,
      export: true,
      type: "disconnected_rejected_requests_by_mentors",
    };
    this.loadShow();
    this.dataService
      .dataExport(data)
      .pipe()
      .subscribe((res) => {
        this.exportSmartMatchList = res["data"];

        this.fieldsToIncludeExcel = [
          "user_name",
          "connect_type",
          "connected_to_name",
          "connection_status",
          "created_at",
        ];

        this.exl = true;

        this.loadHide();
      });
  }

  exportToExcel() {
    this.excelService.generateExcel(
      this.exportSmartMatchList,
      this.fieldsToIncludeExcel,
      "Mentorship Pending Req By Mentor"
    );
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }
}
